import styled from 'styled-components';
import T2 from '../../titles/T2';

const ICON_SIZE = 60;

export const StyledIcon = styled.svg`
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
  color: ${({ color }) => color};
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 24px;
`;

export const StyledContentWrapper = styled.div`
  
`;

export const StyledT2 = styled(T2)`
  margin-bottom:16px;
      `;
